"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
var react_1 = __importStar(require("react"));
var react_select_1 = __importDefault(require("react-select"));
var core_1 = require("@unform/core");
var styles_1 = require("./styles");
var Select = function (_a) {
    var name = _a.name, hasChanged = _a.hasChanged, handleInputError = _a.handleInputError, onChangeEvent = _a.onChangeEvent, messageErrorOnBlur = _a.messageErrorOnBlur, _b = _a.multiSelect, multiSelect = _b === void 0 ? false : _b, rest = __rest(_a, ["name", "hasChanged", "handleInputError", "onChangeEvent", "messageErrorOnBlur", "multiSelect"]);
    var selectRef = react_1.useRef(null);
    var _c = core_1.useField(name), fieldName = _c.fieldName, defaultValue = _c.defaultValue, registerField = _c.registerField, error = _c.error, clearError = _c.clearError;
    var handleBlur = react_1.default.useCallback(function (event) {
        if (!event.target.value) {
            if (!!handleInputError && !!messageErrorOnBlur) {
                handleInputError({
                    inputName: name,
                    message: messageErrorOnBlur,
                });
            }
        }
    }, [handleInputError, messageErrorOnBlur, name]);
    react_1.useEffect(function () {
        registerField({
            name: fieldName,
            ref: selectRef.current,
            path: undefined,
            getValue: function (ref) {
                if (rest.isMulti) {
                    if (!ref.state.value) {
                        return [];
                    }
                    return ref.state.value.map(function (option) { return option.value; });
                }
                if (!ref.state.value) {
                    return '';
                }
                return ref.state.value.value;
            },
            setValue: function (ref, value) {
                ref.select.setValue(value);
                clearError();
            },
        });
    }, [fieldName, registerField, rest.isMulti, clearError, handleBlur]);
    var customStyles = {
        option: function (provided) { return (__assign(__assign({}, provided), { zIndex: 100 })); },
    };
    return (
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    jsx_runtime_1.jsx(styles_1.Container, __assign({ error: !!error }, { children: jsx_runtime_1.jsx(react_select_1.default
        // @ts-ignore
        , __assign({ 
            // @ts-ignore
            isMulti: multiSelect, styles: customStyles, defaultValue: defaultValue, ref: selectRef, classNamePrefix: "sel", onBlur: handleBlur, isClearable: true, onFocus: function () {
                clearError();
            }, onChange: function (event) {
                console.log('changed');
                if (hasChanged) {
                    clearError();
                    hasChanged(event === null || event === void 0 ? void 0 : event.value);
                    // @ts-ignore
                    onChangeEvent(event === null || event === void 0 ? void 0 : event.value);
                }
                if (onChangeEvent)
                    onChangeEvent(event === null || event === void 0 ? void 0 : event.value);
            } }, rest), void 0) }), void 0));
};
exports.default = Select;
//# sourceMappingURL=index.js.map